import { PeriodSelect } from '@/components/TaxReport/PeriodSelect';
import { DateRangePicker } from '@/kit/DatePickers/DateRangePicker';
import { ExportButton } from '@/components/TaxReport/ExportButton';
import { Chips } from '@/components/TaxReport/Chips';
import s from './index.module.scss';

export const FilterViewDesktop = ({ params, setParams, onDateChange }) => {
  return (
    <div>
      <div className={s.header}>
        <div className={s.filters}>
          <PeriodSelect range={params.range} onChange={onDateChange} />
          <DateRangePicker
            range={params.range}
            setRange={onDateChange}
            maxDate={new Date()}
          />
        </div>
        <div className={s.right}>
          <ExportButton />
        </div>
      </div>
      <Chips params={params} setParams={setParams} />
    </div>
  );
};

export default FilterViewDesktop;
